export default "__VITE_ASSET__P2f_$VUx__"